import { Injectable, inject } from "@angular/core";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { HttpClient } from "@angular/common/http";

/*public class OperativeLogDto
{
  public int OperativeLogID { get; set; }
public string EmployeeID { get; set; }
public string Stage { get; set; }
public DateTime LatestDate { get; set; }
public DateTime LatestDateSystem { get; set; }

// Add any other properties you need to share
}*/

//create typescript version of OperativeLogDto
export class OperativeLogDto {
  OperativeLogID: number;
  EmployeeID: string;
  Stage: string;
  LatestDate: Date;
  LatestDateSystem: Date;
  TimesheetCode: string;
}

@Injectable({
  providedIn: "root"
})
export class OperativeLogService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  private static PATHS = {
    GetLatestOperativeLogs:
      "/Services/UniclassRIA-Web-Services-Mobile-OperativeLogs.svc/JSON/GetLatestOperativeLogs"
  };

  /**
   * Parse the .NET style JSON date string (e.g. "/Date(1747753401470+0100)/")
   * into a JavaScript Date object.
   *
   * The numeric portion already represents the UTC timestamp in milliseconds,
   * so we simply convert that value to a Date. The timezone offset portion is
   * informational and should not be applied, otherwise the result will be
   * shifted by an incorrect amount (for example "+0100" would be interpreted as
   * 100 hours using the previous implementation).
   */
  parseJsonDate(jsonDate: string): Date {
    const matches = /\/Date\((\d+)([+-]\d{4})?\)\//.exec(jsonDate);
    if (matches) {
      const timestamp = parseInt(matches[1], 10);
      let date = new Date(timestamp);
      if (matches[2]) {
        const sign = matches[2][0] === "-" ? -1 : 1;
        const hours = parseInt(matches[2].substring(1, 3), 10);
        const minutes = parseInt(matches[2].substring(3, 5), 10);
        const offsetMs = sign * ((hours * 60 + minutes) * 60000);
        date = new Date(timestamp + offsetMs);
      }
      return date;
    }
    return new Date(jsonDate);
  }

  async getLatestOperativeLogsByIDs(
    idList: string[]
  ): Promise<OperativeLogDto[]> {
    const config = await this.clientConfigService.config;
    return new Promise<any>((resolve, reject) => {
      const options = { params: {} };
      this.http
        .post(
          config.urmServices.serviceUrl +
            OperativeLogService.PATHS.GetLatestOperativeLogs,
          { LogRequest: { OperativeIDs: idList } },
          options
        )
        .subscribe(
          (value: any) => {
            const operativeLogs = value.GetLatestOperativeLogsResult.map(
              (log: any) => ({
                ...log,
                LatestDate: this.parseJsonDate(log.LatestDate),
                LatestDateSystem: this.parseJsonDate(log.LatestDateSystem)
              })
            ) as OperativeLogDto[];
            resolve(operativeLogs);
          },
          (error1) => {
            reject(error1);
          }
        );
    });
  }
}
